import React from 'react';

class SimpleGauge extends React.Component{

    constructor(props){
        super(props);
        this.container = React.createRef();
        this.base = React.createRef();
        this.progress = React.createRef();
        this.point = React.createRef();
    }

    run(){
        let color=this.props.color||'#5BB030';
        if(this.props.intervals && this.props.colors){
            let startValue=0;
            this.props.intervals.forEach((element,idx) => {
                if(this.props.percent>=startValue && this.props.percent<element){
                    color=this.props.colors[idx]||color;
                }
                startValue=element;
            });
        }

        let container=this.container.current;
        const width=container.clientWidth;

        let strokeWidth=8;
        // let height=(width/2)+(strokeWidth/2);
        let ratio=(width-(strokeWidth))/2;
        let offset=Math.PI*ratio;

        //container.style.height=height+'px';

        let bar=this.props.percent*offset/100;
        let offsetBar=(offset*2)-bar;

        let circle=this.base.current;
        circle.style.width='100%';
        circle.style.height='100%';
        circle.style.fill='none';
        circle.style.stroke='#E5E5E5';
        circle.style.strokeLinecap='round';
        circle.setAttribute('cx',ratio);
        circle.setAttribute('cy',ratio);
        circle.setAttribute('r',ratio);
        circle.style.strokeDashoffset=offset;
        circle.style.strokeDasharray=offset;
        circle.style.strokeWidth=strokeWidth.toString();
        circle.style.transform=`translate(${strokeWidth/2}px,${strokeWidth/2}px)`;

        circle=this.progress.current;
        circle.style.width='100%';
        circle.style.height='100%';
        circle.style.fill='none';
        circle.style.stroke='#E5E5E5';
        circle.style.strokeLinecap='round';
        circle.setAttribute('cx',ratio);
        circle.setAttribute('cy',ratio);
        circle.setAttribute('r',ratio);
        circle.style.strokeDashoffset=offset;
        circle.style.strokeWidth=strokeWidth.toString();
        circle.style.transform=`translate(${strokeWidth/2}px,${strokeWidth/2}px)`;

        circle=this.point.current;
        circle.style.width='100%';
        circle.style.height='100%';
        circle.style.fill='none';
        circle.style.stroke='#E5E5E5';
        circle.style.strokeLinecap='round';
        circle.setAttribute('cx',ratio);
        circle.setAttribute('cy',ratio);
        circle.setAttribute('r',ratio);
        circle.style.strokeWidth=strokeWidth.toString();
        circle.style.transform=`translate(${strokeWidth/2}px,${strokeWidth/2}px)`;

        let progress=this.progress.current;
        progress.style.stroke=color;
        progress.style.strokeWidth="12px";
        progress.style.strokeDasharray=`${bar} ${offsetBar}`;

        let point=this.point.current;
        point.style.strokeDasharray=`1 ${(offset*2)-1}`;
        point.style.strokeDashoffset=offset-bar;
        point.style.stroke='white';
        point.style.transform=`translate(4px,4px)`;
        point.style.strokeWidth="6px";
    }

    componentDidMount(){
        this.run()
    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        this.run()
    }

    render(){
        return(
            <div className="gauge-container" style={{width:'260px'}} ref={this.container}>
                <svg className="gauge-svg position-relative">
                    <circle ref={this.base}></circle>
                    <circle ref={this.progress}></circle>
                    <circle ref={this.point}></circle>
                </svg>
                <div className="gauge-svg__text" >
                    {this.props.children}
                </div>
            </div>
        );
    }
}

export default SimpleGauge;
